import React, { useState } from 'react';
import {
  Stack,
  Box,
  Heading,
  Text,
  Textarea,
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react';
import dayjs from 'dayjs';

import type { Comment as IComment } from './types/Comment';

interface CommentSectionProps {
  comments: IComment[];

  sendComment: (comment: Pick<IComment, 'content' | 'files'>) => Promise<void>;
}

const Comment = (props: { comment: IComment }) => {
  const { content, created, direction } = props.comment;
  return (
    <Box
      p={5}
      pt={0}
      backgroundColor={['White']}
      shadow="md"
      borderWidth="1px"
      key={props.comment.created}
      rounded="md"
      w="90%"
      mb="3"
      style={{
        marginLeft: direction === 'in' ? 'auto' : undefined,
        marginRight: direction === 'out' ? 'auto' : undefined
      }}
    >
      <Text mt={4}>
        <div dangerouslySetInnerHTML={{ __html: content.replaceAll('\r\n\r\n', '<br />') }}></div>
      </Text>
      <Text as="sub">
        <span style={{ marginRight: '5px' }}>{direction === 'in' ? 'Sinä' : 'Asiakaspalvelija'}</span>
        {dayjs.unix(created).format('DD.MM.YYYY [klo] HH:mm')}
      </Text>
    </Box>
  );
};

export const CommentSection = (props: CommentSectionProps) => {
  const [comment, setComment] = useState({ content: '', files: undefined });
  const [isFeedback, setIsFeedback] = useState(false);
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const onChange = (inputData: FileList | string | null, field: string) => {
    setComment({ ...comment, [field]: inputData });
  };

  const onSubmit = async () => {
    await props.sendComment(comment);
    setComment({ ...comment, content: '' });
    resetFileInput();
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div>
      <Stack align="center" spacing={4}>
        {props.comments
          ? props.comments.map((comment) => {
              return <Comment comment={comment} />;
            })
          : null}
      </Stack>
      <Divider mt={2} mb={2} />
      <div style={{ textAlign: 'center' }} className="survey-link">
        <Modal scrollBehavior="inside" size="full" isOpen={isFeedback} onClose={() => setIsFeedback(false)}>
          <ModalOverlay />
          <ModalContent style={{ padding: 0, width: '850px', height: '800px' }}>
            <ModalHeader>Anna palautetta</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <iframe
                style={{ width: '800px', height: '800px' }}
                src="https://demo-survey.elisadesk.com/a/b1946ac92492d2347c6235b4d2611184"
              ></iframe>
            </ModalBody>
          </ModalContent>
        </Modal>
        <Button
          colorScheme="blue"
          variant="link"
          // onClick={() => window.open('https://demo-survey.elisadesk.com/a/b1946ac92492d2347c6235b4d2611184')}
          onClick={() => setIsFeedback(true)}
        >
          Anna palautetta
        </Button>
      </div>
      <Divider mt={2} mb={2} />
      <Heading fontSize="md">
        <span className="portalNewTicketHeading">Uusi palvelupyyntö</span>
      </Heading>
      <Textarea
        value={comment.content}
        bg="white"
        colorScheme="white"
        onChange={(e) => {
          onChange(e.target.value, 'content');
        }}
      />
      <div style={{ marginTop: '10px', marginBottom: '10px' }}>
        <input
          id="fileupload"
          ref={fileInputRef}
          type="file"
          multiple
          onChange={(e) => onChange(e.target.files, 'files')}
        />
      </div>
      <div>
        <Button colorScheme="blue" onClick={() => onSubmit()}>
          Lähetä
        </Button>
        <Button
          style={{ marginLeft: '10x' }}
          colorScheme="red"
          variant="ghost"
          onClick={() => {
            resetFileInput();
            setComment({ content: '', files: undefined });
          }}
        >
          Tyhjennä
        </Button>
      </div>
    </div>
  );
};

export default CommentSection;
